<template>
    <div class="container">

        <div class="theme-box" v-for="theme in data.themes" :key="theme.theme_name">
            <h2 class="theme-name">{{ theme.theme_name }}</h2>
            <div class="scene-area">
                <div v-for="scene in theme.scene_list" :key="scene.keyword" class="scene-box" 
                    style="margin:10px; height: auto;"  v-on:click="pushRouter(scene.keyword)">
                    <h3 class="scene-title" >{{ scene.name }}</h3>
                    <p class="scene-description">{{ scene.description }}</p>
            </div>
            </div>
        </div>

    </div>
</template>
  
<script>
import { reactive } from 'vue'
import { ChatAPI } from '../api/chat';
// import { useRouter } from 'vue-router'

export default {
    name: 'Tools',
    methods: {
        pushRouter(keyword){
            this.$router.push('/tools/' + keyword)
        },
        querySceneList() {
            ChatAPI.querySceneListSync().then(resp => {
                this.$message({
                    message: "这是一条消息提示",
                    type: "success"
                });
            })
        }
    },
    setup() {
        const data = reactive({
            themes: []
        })
        const querySceneList = async () => {
            const resp = await ChatAPI.querySceneList()
            data.themes = resp
        }
        querySceneList()

        return {
            data
        }
    },
    created() {

    },
    mounted() {

    }
}
</script>
  
<style scoped>
.container {
    max-width: 1440px;
    margin: 0 auto;
}


.theme-box {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
}

.theme-name {
    width: 100%;
    font-size: 1.75rem;
    margin-top: 5px;
    margin-bottom: 10px;
    padding: 0 10px;
}

.scene-area {
    display: flex;
    flex-wrap: wrap;

}

.scene-box {
    flex: 1;
    width: 25%;
    min-width: 300px;
    max-width: 45%;
    min-height: 80px;
    padding: 15px;
    display: flex;
    flex-direction: column;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
}

.scene-box:nth-child(3n+1) {
    margin-left: 0;
}

.scene-box:hover {
    border-color: #663399;
    box-shadow: 0 0 5px rgba(102, 51, 153, 0.3);
    cursor: pointer;
}

.scene-title {
    font-size: 1.2rem;
    margin: 0;
    margin-bottom: 10px;
    color: #663399;
}

.scene-description {
    margin: 0;
    font-size: 1rem;
    color: #00000080;

}

@media screen and (max-width: 768px) {
    .scene-box {
        width: 100%;
    }
}
</style>

<!-- 所有的scene-box宽度一样，同一行的scene-box高度一样，不同行的scene-box高度可以不一样。scene-box的高宽根据屏幕尺寸、scene-description字数动态计算。多个scene-box优先填满一行，在有下一行的情况下，上一行的右边不允许留白。 在内部内容填充正常的情况下，scene-box的高度尽可能小。适配移动端显示，在移动端每个scene-box填充满一行。 -->



// WEBPACK FOOTER //
// src/components/Tools.vue